export default [
  {
    name: 'login',
    path: '',
    component: () => import('@/components/LoginForm.vue'),
    meta: {
      isLogin: true,
    },
  },
  {
    name: 'changePw',
    path: 'changePw',
    //component: SignupPage,
    component: () => import('@/components/ChangePWForm.vue'),
    meta: {
      isLogin: true,
    },
  },
  {
    name: 'dormant',
    path: 'dormant',
    component: () => import('@/components/DormancyAccountForm.vue'),
    meta: {
      isLogin: true,
    },
  },
  {
    name: 'signup',
    path: 'signup',
    //component: SignupPage,
    component: () => import('@/components/JoinForm.vue'),
    meta: {
      isLogin: true,
    },
  },
];
